/* eslint-disable max-len */

import React, { PureComponent } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap';

import * as styles from './styles.scss';

const { changeSubscriptionStyles } = styles;

@connect(state => ({
  user: state.user
}))
class ChangeSubscriptionModal extends PureComponent {
  constructor(props) {
    super(props);
    const currentTime = new Date();
    this.state = {
      specialMessage: null //full modal message, currently used when user decides to stay
    };
    this.messageRedirect = this.props.messageRedirect || '/products/wlc/current-week'; //redirect after special message is seen

    this.handleClose = this.handleClose.bind(this);
    this.handleUpgrade = this.handleUpgrade.bind(this);
    this.handleDowngrade = this.handleDowngrade.bind(this);
  }

  //handles when users changes their mind to not change subscription terms
  handleClose() {
    const { changeSubscriptionFail, changeSubscriptionSuccess } = this.props;

    if (changeSubscriptionFail || changeSubscriptionSuccess || this.props.type === 'downgrade') {
      this.props.toggle('changeSubscriptionOpen');
    } else {
      // choose to not upgrade
      this.setState({
        specialMessage: {
          heading: 'Thanks for considering upgrading.',
          body: 'We’re so glad that you’re part of our community of WHOLE Lifers! Please let us know if there is something we can do to make WLC even better!',
          button: {
            text: 'Go to the Weekly Guide',
            href: this.messageRedirect
          }
        }
      });
    }
  }

  handleUpgrade() {
    const { currentOrderId, annualPrice, upgradeSubscription } = this.props;
    this.setState({ changeSubscriptionPending: true });
    upgradeSubscription(currentOrderId, annualPrice);
  }

  handleDowngrade() {
    const { currentOrderId, monthlyPrice, downgradeSubscription } = this.props;
    this.setState({ changeSubscriptionPending: true });
    downgradeSubscription(currentOrderId, monthlyPrice);
  }

  render() {
    const {
      isOpen,
      annualPrice,
      monthlyPrice,
      showTrialUpgradeCopy,
      upgradeCopy,
      changeSubscriptionFail,
      changeSubscriptionSuccess,
      type
    } = this.props;
    const { specialMessage, changeSubscriptionPending } = this.state;

    //construct the subscription new start date
    const d = new Date();
    const currentMonth = d.getMonth() + 1; //getMonth returns 0-11
    let currentYear = d.getFullYear();
    let startMonth = currentMonth + 1;
    if (startMonth === 13) {
      startMonth = 1;
      currentYear = currentYear + 1;
    }

    if (specialMessage) {
      return (
        <Modal isOpen={isOpen} centered>
          <ModalHeader className="px-5" id="changeSubscriptionModalHeader">
            {specialMessage.heading}
          </ModalHeader>
          <ModalBody className="p-5">{specialMessage.body}</ModalBody>
          <ModalFooter>
            <Button
              color="light"
              onClick={() => {
                this.props.toggle('changeSubscriptionOpen');
                this.props.refreshSubscriptions();
                this.setState({ specialMessage: null });
              }}
              className="mr-3"
            >
              Close
            </Button>
            <Button color="primary" href={specialMessage.button.href} onClick={specialMessage.button.onClick}>
              {specialMessage.button.text}
            </Button>
          </ModalFooter>
        </Modal>
      );
    }

    return (
      <Modal isOpen={isOpen} centered size="lg">
        <ModalHeader className="px-5" id="changeSubscriptionModalHeader">
          {changeSubscriptionFail
            ? 'Whoops!'
            : type === 'upgrade'
              ? 'Complete your WLC membership upgrade...'
              : 'Confirm Your Switch to Monthly Billing'}
        </ModalHeader>
        <ModalBody className="p-5">
          {changeSubscriptionSuccess && !changeSubscriptionFail ? (
            <span>
              {type === 'upgrade' ? 'Your upgrade was successful.' : 'Your switch to monthly billing was successfully.'}
            </span>
          ) : null}
          {changeSubscriptionFail && !changeSubscriptionSuccess ? (
            <span>
              We weren't able to change this subscription for you. For immediate help, please contact customer service
              at support@foodrevolution.org.
            </span>
          ) : null}
          {!changeSubscriptionSuccess && !changeSubscriptionFail ? (
            type === 'upgrade' ? (
              <div>
                {showTrialUpgradeCopy
                  ? `Save money when you upgrade your subscription to annual! You’ll pay $${annualPrice}/year, for annual savings of $${upgradeCopy.savings}. You'll be billed at the end of your current free trial and can cancel at any time.`
                  : `Save money when you upgrade your subscription to annual! Instead of $${upgradeCopy.currentMonthlyAmount}/month, you'll pay $${annualPrice}/year, for annual savings of $${upgradeCopy.savings}. You'll be billed starting at the end of your current subscription and can cancel at any time.`}
                <br />
                <br />
                <strong>
                  {`You'll be automatically billed $${annualPrice}/year starting on ${upgradeCopy.copyBillingDateString}`}
                </strong>
              </div>
            ) : (
              <div>
                {`You’re choosing more flexibility! Your membership will continue at $${monthlyPrice}/month, starting on ${upgradeCopy.copyBillingDateString}, when your current annual subscription ends.`}
                <br />
                <br />
                <strong>
                  {`You’ll still have access to everything WHOLE Life Club offers — with a monthly payment of $${monthlyPrice}/month instead. And of course, you can cancel anytime.`}
                </strong>
              </div>
            )
          ) : null}
        </ModalBody>
        <ModalFooter>
          <div>
            <Button
              color="light"
              onClick={this.handleClose}
              style={{ cursor: 'pointer' }}
              disabled={!(changeSubscriptionSuccess || changeSubscriptionFail) && !!changeSubscriptionPending}
            >
              Close
            </Button>
            {changeSubscriptionFail || changeSubscriptionSuccess ? null : (
              <Button
                color="primary"
                onClick={type === 'upgrade' ? this.handleUpgrade : this.handleDowngrade}
                style={{ cursor: 'pointer' }}
                disabled={!!changeSubscriptionPending}
              >
                {changeSubscriptionPending
                  ? 'Processing...'
                  : type === 'upgrade'
                    ? 'Complete Upgrade'
                    : 'Adjust Your Billing'}
              </Button>
            )}
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withRouter(ChangeSubscriptionModal);
